// Serbian translations
export const sr: Record<string, string> = {
  'menu.dashboard': 'Контролна табла',
  'menu.orderNew': 'Регистрација производа',
  'menu.customers': 'Купци',
  'menu.products': 'Производи',
  'menu.users': 'Корисници',
  'menu.settings': 'Подешавања',
  'menu.logout': 'Одјава',
  'dashboard.title': 'Контролна табла',
  'dashboard.todaySales': 'Продаја данас',
  'dashboard.totalOrders': 'Укупно наруџби',
  'dashboard.newOrder': 'Нова наруџба',
  'dashboard.newCustomer': 'Нови купац',
  'order.title': 'Нова наруџба',
  'order.customer': 'Купац',
  'order.products': 'Производи',
  'order.quantity': 'Количина',
  'order.price': 'Цена',
  'order.total': 'Укупно',
  'order.payment': 'Плаћање',
  'order.cash': 'Готовина',
  'order.card': 'Картица',
  'users.title': 'Корисници',
  'users.name': 'Име',
  'users.email': 'Имејл',
  'users.role': 'Улога',
  'users.edit': 'Измени',
  'users.delete': 'Обриши',
  'common.yes': 'Да',
  'common.no': 'Не',
  'common.cancel': 'Откажи',
  'common.save': 'Сачувај',
  'common.search': 'Претрага',
  'common.loading': 'Учитавање...',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Пријава',
  'login.enterPin': 'Унесите ПИН',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'Регистрација',
  'signup.createAccount': 'Направи налог',
  'signup.email': 'Имејл',
  'signup.phone': 'Телефон',
  'menu.reportsAndAccounting': 'Извештаји и рачуноводство',
  'menu.systemAndCommunication': 'Систем и комуникација',
};
